/**
 * SectionHeader — gray uppercase label above a detail-page section
 * (GROUPS, NOTE, WE MET, ABOUT, PHOTOS, CONTACTS, SHARED).
 *
 * Shared across the three connection detail pages so section labels stay
 * visually consistent. Just styled text.
 *
 * @param {React.ReactNode} children - The label text
 * @param {object} [style] - Optional style overrides
 */
const SectionHeader = ({ children, style }) => (
  <div
    style={{
      fontSize: '12px',
      fontWeight: 600,
      letterSpacing: '0.5px',
      textTransform: 'uppercase',
      color: '#8E8E93',
      marginBottom: '8px',
      width: '100%',
      textAlign: 'left',
      ...style,
    }}
  >
    {children}
  </div>
);

export default SectionHeader;
